// Subscription Service for NotaryOS
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const subscriptionService = {
  // Get current subscription status
  async getStatus(token) {
    const response = await fetch(`${API_URL}/api/subscription/status`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to get subscription status');
    return response.json();
  },

  // Get usage statistics
  async getUsage(token) {
    const response = await fetch(`${API_URL}/api/subscription/usage`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to get usage stats');
    return response.json();
  },

  // Get available plans
  async getPlans() {
    const response = await fetch(`${API_URL}/api/subscription/plans`);
    if (!response.ok) throw new Error('Failed to get plans');
    return response.json();
  },

  // Create checkout session
  async createCheckout(token, packageId) {
    const originUrl = window.location.origin;
    const response = await fetch(`${API_URL}/api/payments/checkout`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        package_id: packageId,
        origin_url: originUrl
      })
    });
    if (!response.ok) throw new Error('Failed to create checkout');
    return response.json();
  },

  // Check payment status
  async checkPaymentStatus(token, sessionId) {
    const response = await fetch(`${API_URL}/api/payments/status/${sessionId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to check payment status');
    return response.json();
  },

  // Check feature access
  async checkFeatureAccess(token, feature) {
    const response = await fetch(`${API_URL}/api/feature-access/${feature}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to check feature access');
    return response.json();
  }
};

export default subscriptionService;
